import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--parchment)]" data-testid="public-layout">
      <TopBar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
